import { connect } from "react-redux";
import { ItemViewProps, mapDispatchToItemProps, mapStateToItemProps } from "../item.controll";
import { Item } from "../item.model";
import { Select as ViewList } from "../../../components/select";
import { Alert, Box, Paper, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { ItemCadastro } from "./item.cad";
import { formatMoney } from "../../../services/utils";
import { TabelaPrecoItem } from "../../../data.types";
import { Warning } from "@mui/icons-material";

const getTabelaPreco = (tabela: TabelaPrecoItem[]) => {
    if (tabela.length > 0)
        return (
            <Box sx={{ display: "flex", flex: 1, flexDirection: "row",gap:1, justifyContent:"center",alignItems:"center" }}>
                {tabela.map((tabela, idx) => (
                    <Paper key={idx} sx={{ display: "flex", flex: 1, flexDirection: "column", alignContent: "center", justifyContent: "center", bgcolor:tabela.ativo?"Background":"brown" }}>
                        <Typography variant="caption" textAlign={"center"}>{tabela.descricao}</Typography>
                        <Typography variant="caption" textAlign={"center"}>{formatMoney(tabela.valor)}</Typography>
                    </Paper>
                ))}
            </Box>
        )
    return <Box sx={{display:"flex",flex:1,flexDirection: "row",alignItems:"center"}}><Warning color="warning"/> <Typography>Indefinido</Typography></Box>
}

const columns: GridColDef[] = [
    { field: 'codigo', headerName: 'Código', flex: 2 },
    { field: 'descricao', headerName: 'Descricão', flex: 3 },
    //{ field: 'preco_var', headerName: 'Preço Var.', flex: 2, renderCell:(prm)=> formatMoney(prm.value)},
    //{ field: 'preco_ata', headerName: 'Preço Ata.', flex: 2, renderCell:(prm)=> formatMoney(prm.value)},
    { field: 'tabela_preco', headerName: 'Preço', flex: 3, renderCell: (prm) => getTabelaPreco(prm.value ? prm.value : []) },
    //{ field: 'saldo', headerName: 'Estoque', flex: 1 },
    { field: 'ativo', headerName: 'Ativo?', flex: 2, renderCell: (prm) => prm.value ? "Sim" : "Não" },
]

function ItemList(props: ItemViewProps) {
    const { itemActions, itemState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status, showCadModal, changeList } = itemState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, setShowCadModal } = itemActions

    useEffect(() => {
        read()
    }, [])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        setShowCadModal(false)
    }

    function Cadastro() {
        return ItemCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            width: "md",
            heigth: "auto",
        })
    }

    const List = () => {
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Itens cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                orderBy="codigo"
                columns={columns}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => read()
                }}
                ListItemTextPrimary={(row: Item) => <Typography component={"span"}>{row.descricao}</Typography>}
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToItemProps, mapDispatchToItemProps)(ItemList);
